import Vue from 'vue'
import { beforeRouteEnter } from '@assets/js/routerPageHook.js'
import PageForm from '@shared/ui/public/forms/PageForm.vue'
import materials from '@components/ui-components/materials/component.js'
import caseItem from '@components/ui-components/case/component.js'
import titleLink from '@components/ui-components/title-link/component.js'
import filterContainer from '@ui/filter-container/filter-container'
import Pagination from '@ui/pagination/pagination'
import { router } from '@src/routes'
import { mapState } from 'vuex'

export default {
  name: 'index',
  data() {
    return {
      template: '<main></main>',
      decisionsSwiper: {
        spaceBetween: 32,
        parallax: true,
        speed: 700,
        loop: true,
        autoplay: {
          delay: 8000,
        },
        pagination: {
          el: '.js-decisions-pag',
          clickable: true,
        },
      },
      visibleText: false,
      visibleBtn: false,

      heightFull: null,
      heightHide: null,
      height: null,

      isEndSlide: false,
      isFirstSlide: true,

      activeIndex: -1,
      openItems: false,
      pagination: null,
    }
  },
  computed: {
    ...mapState('mobile', ['isMobile', 'isTablet']),
  },
  components: {
    'page-form-cmp': PageForm,
    'materials-cmp': materials,
    'case-cmp': caseItem,
    'title-link-cmp': titleLink,
    'filter-container-cmp': filterContainer,
    'pagination-cmp': Pagination,
  },
  methods: {
    openDesc() {
      this.visibleText = !this.visibleText
      if (this.visibleText) {
        this.height = this.heightFull
      } else {
        this.height = this.heightHide
      }
    },
    setActiveIndex(index) {
      this.activeIndex = this.activeIndex === index ? -1 : index
      this.openItems = false
    },
    clickBtn(link, openInNewWindow) {
      if (openInNewWindow === 1) {
        let linkWithParams = this.$router.history.base + link
        window.open(linkWithParams, '_blank')
      } else {
        this.$router.push(link)
      }
    },
  },
  mounted() {
    setTimeout(() => {
      let leftHeight = this.$refs.containerLeft ? this.$refs.containerLeft.clientHeight : 0
      let rightHeight = this.$refs.containerRight ? this.$refs.containerRight.clientHeight : 0
      if (leftHeight && rightHeight && leftHeight > rightHeight && leftHeight > 400) {
        this.visibleBtn = true
        setTimeout(() => {
          this.heightFull = this.$refs.containerLeft.clientHeight
          this.heightHide = Math.max(rightHeight, 400)
          this.height = Math.max(this.heightHide, 400)
        }, 10)
      } else {
        this.visibleText = true
      }
    }, 100)
  },
  beforeRouteUpdate(to, from, next) {
    const path = to.path.replace(router.history.base, '')
    Vue.http.get(`templates${path}`, { params: to.query }).then(
      data => {
        next()
        this.template = data.data
      },
      () => {
        next('/404')
      }
    )
  },
  beforeRouteEnter,
  render(createElement) {
    return Vue.compile(this.template).render.call(this, createElement)
  },
}



// WEBPACK FOOTER //
// ./src/templates/pages/vendors/view/index.js